import React from "react";

import { Check } from "lucide-react";

import { Button, Card, CardContent } from "@/components/ui";

import type { AttributeReviewBatchBarProps } from "./AttributeReviewBatchBar.types";

export const AttributeReviewBatchBar: React.FC<
  AttributeReviewBatchBarProps
> = ({ selectedCount, onBatchApprove }) => {
  return (
    <Card className="mb-4 border-indigo-200 dark:border-indigo-800 bg-indigo-50/50 dark:bg-indigo-950/30">
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <span className="text-sm font-medium text-indigo-700 dark:text-indigo-300">
              {selectedCount} mapping{selectedCount !== 1 ? "s" : ""} selected
            </span>
          </div>
          <div className="flex items-center gap-2">
            <Button
              data-testid="batch-approve-btn"
              size="sm"
              onClick={onBatchApprove}
              className="bg-emerald-600 hover:bg-emerald-700"
            >
              <Check className="w-4 h-4" />
              Approve ({selectedCount})
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
